import { logger as lambdaLogger } from '@hashnode/lambda-logger'
import { Logger } from './logging'

export class LambdaLoggerAdapter implements Logger {
	log(message: string, rest: any): void {
		lambdaLogger.info(message, rest as any)
	}

	success(message: string, rest: any): void {
		lambdaLogger.info(message, rest as any)
	}

	info(message: string, rest: any): void {
		lambdaLogger.info(message, rest as any)
	}

	warn(message: string, rest: any): void {
		lambdaLogger.warn(message, rest as any)
	}

	error(message: string, rest: any): void {
		lambdaLogger.error(message, rest as any)
	}

	debug(message: string, rest: any): void {
		lambdaLogger.debug(message, rest as any)
	}
	clear(): void {}
	exit(): never {
		process.exit(1)
	}

	time(): void {}

	timeEnd(): void {}
}
